module.exports = __webpack_public_path__ + "img/banner_03.76374893.jpg";